import React from 'react';

import { currencyFormat } from '../../../../../../utils/helpers/numberHelper';
import { PAYMENT_HANDLED_BY } from '../../../utils/enums';
import { getLatestVersion } from '../../../utils/es6Helpers';

import SubscriptionMessage from './pricing/SubscriptionMessage';
import { StyledTitle, StyledText } from './styles';

const Pricing = (props) => {
  const { app } = props;
  const version = getLatestVersion(app);
  const { isSubscriptionToAnotherSoftwareVendorRequired, supportEmail } = app;
  const { setupFee, monthlyFee } = version;
  const { paymentHandledBy } = app;

  if (paymentHandledBy === PAYMENT_HANDLED_BY.EXTERNAL) {
    return (
      <div>
        <StyledTitle>Pricing</StyledTitle>
        <StyledText>
          Contact developer for pricing at{' '}
          <a href={`mailto:${supportEmail}`} target="_blank" rel="noreferrer">
            {supportEmail}
          </a>
        </StyledText>
        <SubscriptionMessage
          show={isSubscriptionToAnotherSoftwareVendorRequired}
        />
      </div>
    );
  }

  if (setupFee === 0 && monthlyFee === 0) {
    return (
      <div>
        <StyledTitle>Pricing</StyledTitle>
        <StyledText block>Free</StyledText>
        <SubscriptionMessage
          show={isSubscriptionToAnotherSoftwareVendorRequired}
        />
      </div>
    );
  }

  return (
    <div>
      <StyledTitle>Pricing</StyledTitle>
      {setupFee > 0 && (
        <StyledText block>
          There is a one-time setup fee of {currencyFormat(setupFee)}
        </StyledText>
      )}
      {monthlyFee > 0 && (
        <>
          <StyledText>
            {currencyFormat(monthlyFee)} will be billed monthly
          </StyledText>
        </>
      )}
      <SubscriptionMessage
        show={isSubscriptionToAnotherSoftwareVendorRequired}
      />
    </div>
  );
};

export default Pricing;
